export default __webpack_public_path__ + "static/media/vp1_2025.2cde40a6.jpg";